import { render, staticRenderFns } from "./TableForPage.vue?vue&type=template&id=cf5a16de&scoped=true"
import script from "./TableForPage.vue?vue&type=script&lang=js"
export * from "./TableForPage.vue?vue&type=script&lang=js"
import style0 from "./TableForPage.vue?vue&type=style&index=0&id=cf5a16de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5a16de",
  null
  
)

export default component.exports